export function Brand(){return <span className="book-brand"><img src="/brand-flower.svg" alt="" width="44" height="44"/><span><strong>Book</strong><small>with Assemble</small></span></span>;}
